module.exports = __webpack_public_path__ + "img/python.abd442bc.png";